<template>
    <div>
        <CuentaAtras @tiempoTerminado="tiempoTerminado"  :tiempo="20"/>
        <PageTitle
            :title="teatro.hash === 'UHmERrsRV19JCGQMg7Is' ? $t('nuevo_abono.titulo_copa', { titulo:  lista_abonados.nombre }) : $t('nuevo_abono.titulo', { temporada: lista_abonados.nombre, abono: teatro.texto_abono })"
            class="strech"
        />

        <IdentificacionPrivadaStep
            v-if="requiereIdentificacion && (!identificacionValida || showIdentificacionStep)"
            :loading="identificacionLoading"
            :error="error"
            :errors-validacion="errorsValidacion"
            :referente="referente"
            @submit="onIdentificarSubmit"
            @reset="onIdentificarReset"
        />


        <!--
            Visual gate (Fix 1, round 3):
            The wizard content (zone map, seat selection, parking, paso3, voucher, etc.)
            is mutually exclusive with the identification step. When identification is
            required AND the user has not yet identified (or a re-identify is forced),
            ONLY the identification step is shown. This prevents the user from seeing
            both the step and the rest of the wizard at the same time.
        -->
        <div
            v-if="!requiereIdentificacion || (identificacionValida && !showIdentificacionStep)"
            data-test="wizard-content"
        >
            <div v-if="buscando_abonado && (esRenovacionConAsiento || $route.query.abonado_ids)" style="min-height: 400px; padding-top: 120px; padding-bottom: 40px;">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <LoaderComponent/>
                        </div>
                    </div>
                </div>
            </div>

            <template v-if="!$route.query.abonado_ids && !esRenovacionConAsiento">
                <template v-if="teatro.hash === 'hvLux5tvnE5HMsDiXOt2' && url.includes('n_abonado_antiguo')">
                    <SeleccionarAsientosConRegiones
                        v-if="recinto && recinto.tipo_proceso_online == 1 && abonado && !plazas_parking"
                        :disabled="paso3 || plazas_parking"
                        :changeSeat="changeSeat"
                        :abonado="abonado"
                        :key="reloadComponent"
                        :bloquear="bloquearAsientosWrapper"
                        @butacasBloqueadas="butacasBloqueadas"
                        @identificacion-invalida="onIdentificacionInvalidaEnBloqueo"
                    />
                </template>
                <template v-else>
                    <SeleccionarAsientosConRegiones
                        v-if="!buscando_abonado && recinto && recinto.tipo_proceso_online == 1 && !plazas_parking"
                        :disabled="paso3 || plazas_parking"
                        :changeSeat="changeSeat"
                        :abonado="abonado"
                        :key="reloadComponent"
                        :bloquear="bloquearAsientosWrapper"
                        @butacasBloqueadas="butacasBloqueadas"
                        @identificacion-invalida="onIdentificacionInvalidaEnBloqueo"
                        @sessionButacaData="sessionButacaDataPadre"
                    />
                </template>
            </template>

            <template v-if="!$route.query.abonado_ids && !esRenovacionConAsiento">
                <SeleccionarAsientosMapaGeneral
                    v-if="recinto && recinto.tipo_proceso_online == 3"
                />

                <SeleccionarAsientoConSecciones
                    v-if="recinto && recinto.tipo_proceso_online == 2"
                    :disabled="paso3 || plazas_parking"
                    :changeSeat="changeSeat"
                    :abonado="abonado"
                    :bloquear="bloquearAsientosWrapper"
                    @butacasBloqueadas="butacasBloqueadas"
                    @identificacion-invalida="onIdentificacionInvalidaEnBloqueo"
                />
            </template>
            <template v-else-if="esRenovacionConAsiento">
                <SeleccionarAsientosConRegiones
                    v-if="!buscando_abonado && recinto && recinto.tipo_proceso_online == 1"
                    v-show="!plazas_parking"
                    :disabled="paso3 || plazas_parking"
                    :changeSeat="changeSeat"
                    :abonado="abonado"
                    :key="reloadComponent"
                    :bloquear="bloquearAsientosWrapper"
                    @butacasBloqueadas="butacasBloqueadas"
                    @identificacion-invalida="onIdentificacionInvalidaEnBloqueo"
                    @sessionButacaData="sessionButacaDataPadre"
                />
            </template>

            <div id="plazas_parking" v-if="!$route.query.abonado_ids && !esRenovacionConAsiento && zonas_anexas_disponibles && plazas_parking && recinto && (recinto.tipo_proceso_online == 1 || recinto.tipo_proceso_online == 2)">
                <PasoExtraPlazasParking
                    ref="pasoExtraPlazasParking"
                    :disabled="paso3"
                    :abonado="abonado"
                    :changeSeat="changeSeat"
                    :tipoProcesoOnline="recinto.tipo_proceso_online"
                    @avanzarPaso="avanzarPaso"
                    @butacasBloqueadas="butacasBloqueadas"
                    @sessionButacaData="sessionButacaDataPadre"
                    @continuarSinPlazaParking="continuarSinPlazaParking"
                    @volverButacas="volverDesdeParking"
                />
            </div>

            <transition name="fade" mode="out-in">
                <section
                    class="padding-vertical-content lightgray-content mb-3 mb-lg-4"
                    v-if="paso3"
                    key="paso3"
                    id="paso3"
                >
                    <div class="container">
                        <div class="row">
                            <b-col cols="12">
                                <h2 class="h1 text-uppercase">{{ $t('nuevo_abono.completa_datos') }}</h2>
                                <div class="subtitle h3 light mb-3">{{ $t('nuevo_abono.completa_info', {abono: teatro.texto_abono}) }}</div>
                            </b-col>
                            <div class="col-12">
                                <ValidationObserver tag="form" ref="observer" @submit.prevent="finalizarPasoTres()">
                                    <div v-for="(abono, index) in datos_compradores" :key="index">
                                        <DatosAbonoComponent
                                            :abono="abono"
                                            :generos="generos"
                                            :index="++index"
                                            :descuentos="zona?.precios"
                                            :tipos_abonos="abono.tipos_abonos ?? zona?.tipos_abonos"
                                            :desactivar="paso4 || resumen || voucher ? true : false"
                                            :validator="$refs.observer"
                                            :error_telefono="error_telefono" @imagenSubida="documentacion_error = false"
                                            :session_id="session_id"
                                            @errorDatos="datos_abono_error = $event"
                                            @updateAbono="actualizarDatosAbonado($event)"
                                            @precioDisponible="precio_disponible = $event"
                                        />
                                    </div>
                                    <div class="mt-4" v-if="datos_abono_error">
                                        <b-alert show variant="danger">
                                            <h3>
                                                {{ $t('renovar_abono.no_precios') }}
                                            </h3>
                                        </b-alert>
                                    </div>
                                    <div class="mt-4" v-if="documentacion_error">
                                        <h4 class="text-danger">
                                            {{ $t('nuevo_abono.error_documentacion') }}
                                        </h4>
                                    </div>
                                    <div class="mt-4" v-if="dni_error">
                                        <h4 class="text-danger">
                                            {{$t('nuevo_abono.existe_dni', {abono: teatro.texto_abono})}}
                                        </h4>
                                    </div>
                                    <div class="mt-4" v-if="!precio_disponible">
                                        <h4 class="text-danger">
                                            {{ $t('nuevo_abono.error_precio') }}
                                        </h4>
                                    </div>
                                    <div class="mt-4">
                                        <Button
                                            v-if="!datos_abono_error"
                                            id="compra-responsive"
                                            type="submit"
                                            :label="$t('nuevo_abono.continuar_compra')"
                                            :disabled="paso4 || resumen || dniCheckLoading"
                                        />
                                        <Button
                                            id="atras-responsive"
                                            type="button"
                                            :label="$t('nuevo_abono.volver_compra')"
                                            :disabled="paso4 || resumen || voucher"
                                            custom-class="ml-2"
                                            @click="cambiarAsiento"
                                        />
                                    </div>
                                </ValidationObserver>
                            </div>
                        </div>
                    </div>
                </section>
            </transition>

            <div v-if="lista_abonados.permitir_envio_a_domicilio">
                <transition name="fade" mode="out-in">
                    <section class="padding-vertical-content" v-if="paso4" key="paso4" id="paso4">
                        <div class="container">
                            <div class="row">
                                <EnviosComponent
                                    :datos_compradores="datos_compradores"
                                    :desactivar="voucher || resumen ? true : false"
                                    @envioSolicitado="envioSolicitado"
                                    @continuarSinEnvio="showVoucher"
                                    @atras="volverDesdePreguntaEnvio"
                                />
                            </div>
                        </div>
                    </section>
                </transition>
            </div>
            <transition name="fade" mode="out-in">
                <section
                    :class="'padding-vertical-content ' + (lista_abonados.permitir_envio_a_domicilio ? 'lightgray-content' : '')"
                    v-if="voucher && !ocultarCupon"
                    key="voucher"
                    id="voucher"
                >
                    <div class="container">
                        <div class="row">
                            <b-col cols="12" class="mt-3 mb-3">
                                <CheckVoucherComponent
                                    :sesion_id="session_id"
                                    :datos="datos_compradores"
                                    :desactivar="resumen || procesar_pago || preguntaParcelas ? true : false"
                                    :loading="resumen_loading"
                                    @volver="voucher = false"
                                    @continuar="cuponAplicado()"
                                />
                            </b-col>
                        </div>
                    </div>
                </section>
            </transition>

            <transition name="fade" mode="out-in">
                <PreguntaPrevioPasoParcelas
                    :mostrar="preguntaParcelas"
                    :loading="loading"
                    :botonesDeshabilitados="botonesParcelasDeshabilitados"
                    @quiereParcelas="respuestaParcelas"
                    @volver="volverDesdePreguntaParcelas"
                />
            </transition>

            <transition name="fade" mode="out-in">
                <PasoCompraParcelasOnline
                    ref="pasoParcelasRef"
                    :mostrar="pasoSeleccionParcelas"
                    :datosCompradores="datos_compradores"
                    :loading="loading"
                    :sesiones="sessiones"
                    @continuar="continuarDespuesdeAsignaciones"
                    @volver="volverDesdeSeleccionParcelas"
                />
            </transition>

            <transition name="fade" mode="out-in">
                <section
                    :class="'padding-vertical-content mb-3 mb-lg-4 ' + (!lista_abonados.permitir_envio_a_domicilio || quiereParcelasCambiarColor  ? 'lightgray-content' : 'bg-white')"
                    v-if="resumen"
                    key="resumen"
                    id="resumen"
                >
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <template v-if="!resumen_error">
                                    <h2 class="m-0 h1 text-uppercase">{{ $t('nuevo_abono.resumen_compra') }}</h2>
                                    <div class="subtitle h3 light mb-3 mb-lg-5">{{ $t('nuevo_abono.revisa_datos') }}</div>
                                    <ResumenCompraComponent
                                        :entradas="asientos"
                                        :formulario="formulario"
                                        :datos_guardados="datos_guardados"
                                        :envio_domicilio="envio_domicilio"
                                        :datos_parcelas_compra="datos_parcelas_compradas"
                                        @solicitarPlazos="aplicarPlazos"
                                        @compraConfirmada="compraConfirmada"
                                        :iva="footer.iva_abono"
                                        :activar_referidos="teatro.activar_referidos && ! renovacion"
                                        :session_id="session_id"
                                        @aplicarDescuento="aplicarDescuento"
                                        @cancelarDescuento="cancelarDescuento"
                                        @resetPlazos="resetPlazos"
                                        :loading="resumen_loading"
                                        :desactivar="procesar_pago ? true : false"
                                        @volver="volverDesdeResumenCompra"
                                    />
                                </template>
                                <template v-else>
                                    <h2 class="m-0 h1 text-uppercase">{{ resumen_error }}</h2>
                                </template>
                            </div>
                        </div>
                    </div>
                </section>
            </transition>

            <transition name="fade" mode="out-in">
                <section
                    v-if="procesar_pago"
                    :class="'padding-vertical-content mb-3 mb-lg-4 ' + (lista_abonados.permitir_envio_a_domicilio ? 'lightgray-content' : '')"
                    key="pago"
                    id="pago"
                >
                    <div class="container">
                        <div class="row">
                            <div class="col-12">
                                <h2 class="m-0 h1 text-uppercase">{{ $t('compra.confirmacion_compra') }}</h2>
                                <div class="subtitle h3 light mb-3 mb-lg-5">{{ $t('compra.introduce_datos') }}</div>
                                <PagoPaycometComponent
                                    ref="pago"
                                    :tipo_venta="tipo_venta"
                                    :jet_id="jet_id"
                                    :session_id="session_id"
                                    :es-plazos="hayPlazos"
                                    :importe-carrito="icImporteCarrito"
                                    :gastos-gestion-unitarios="icGastosGestionUnitarios"
                                    :num-abonados="icNumAbonados"
                                    :store="$store"
                                    :get-vuex-alias="config.getVuexAlias"
                                />
                            </div>
                        </div>
                    </div>
                </section>
            </transition>
        </div>
    </div>
</template>

<script>
    import DatosAbonoComponent from '@/components/frontend/abonos/nuevo/DatosAbonoComponent';
    import ResumenCompraComponent from '@/components/frontend/abonos/nuevo/ResumenCompraComponent.vue';
    import PagoPaycometComponent from "@/components/frontend/compra/components/PagoPaycometComponent.vue";
    import { useAbonoTracking } from '@/composables/front/analytics/useAbonoTracking';
    import EnviosComponent from '@/components/frontend/abonos/nuevo/EnviosComponent.vue';
    import CheckVoucherComponent from '@/components/frontend/abonos/nuevo/CheckVoucherComponent.vue';
    import SeleccionarAsientosConRegiones from '@/components/frontend/abonos/nuevo/SeleccionarAsientosConRegiones.vue';
    import SeleccionarAsientosMapaGeneral from '@/components/frontend/abonos/nuevo/SeleccionarAsientosMapaGeneral.vue';
    import SeleccionarAsientoConSecciones from './SeleccionarAsientoConSecciones.vue';
    import PageTitle from '@/components/frontend/shared/PageTitle';
    import CuentaAtras from '@/components/frontend/events/compra/CuentaAtras';
    import PasoCompraParcelasOnline from '@/components/frontend/abonos/parcelas/PasoCompraParcelasOnline.vue';
    import PreguntaPrevioPasoParcelas from '@/components/frontend/abonos/parcelas/PreguntaPrevioPasoParcelas.vue';
    import PasoExtraPlazasParking from './PasoExtraPlazasParking.vue';
    import { useHead } from '@/composables/common/seo/useHead';
    import Button from '@/modules/ui/Button.vue';
    import LoaderComponent from '@/components/preloader/LoaderComponent.vue';
    import IdentificacionPrivadaStep from '@/modules/front/abonos/nuevo/IdentificacionPrivadaStep.vue';
    import { useVentaPrivadaAbonos } from '@/composables/front/checkout/useVentaPrivadaAbonos';
    import { useAbonoCartTotal } from '@/composables/front/checkout/useAbonoCartTotal';
    import { getCurrentInstance } from 'vue';

    export default {
        data() {
            return {
                paso3: false,
                paso4: false,
                pasoSeleccionParcelas: false,
                resumen: false,
                zona: null,
                asientos: [],
                datos_compradores: [],
                session_id: null,
                formulario: null,
                datos_guardados: null,
                loading: false,
                resumen_loading: false,
                resumen_error: null,
                documentacion_error: false,
                direccion_envio_abono: '',
                time_left: null,
                compra_loading: null,
                procesar_pago: false,
                envio_domicilio: false,
                jet_id: null,
                dni_error: false,
                dniCheckLoading: false,
                datos_abono_error: null,
                voucher: false,
                reloadComponent: 1,
                changeSeat: 1,
                abonado: null,
                error_telefono: 0,
                tipo_venta: 'abono',
                esMovil: false,
                preguntaParcelas: false,
                botonesParcelasDeshabilitados: false,
                cart_ids_parcelas: [],
                quiereParcelasCambiarColor: false,
                datos_parcelas_compradas: [],
                sessiones: [],
                plazas_parking: false,
                buscando_abonado: true,
                zonas_anexas: [],
                precio_disponible: true,
                showIdentificacionStep: false
            }
        },
        setup() {
            const instance = getCurrentInstance();
            const composable = useVentaPrivadaAbonos({
                getQueryParams: () => instance.proxy.$route.query
            });
            const cartTotal = useAbonoCartTotal({
                getDatosGuardados: () => instance.proxy.datos_guardados,
                getEnvioDomicilio: () => instance.proxy.envio_domicilio,
                getListaAbonados: () => instance.proxy.lista_abonados,
                getDatosParcelasCompra: () => instance.proxy.datos_parcelas_compradas
            });
            const { loading: identificacionLoading, ...ventaPrivadaApi } = composable;
            return {
                ...ventaPrivadaApi,
                identificacionLoading,
                ...cartTotal
            };
        },
        created() {
            useHead('Venta de abonos');

            if (this.manager.lfp) {
                this.tipo_venta = 'abono-alta-lfp';
            }

            if (this.abono_envio) {
                this.abono_envio.gastos_envio = this.lista_abonados.precio_envio_a_domicilio;
            }

            if(this.$route.query.n_abonado_antiguo || this.$route.query.dni) {
                this.buscarAbonado(this.$route.query.n_abonado_antiguo, this.$route.query.dni)
            } else {
                this.buscando_abonado = false;
            }

            this.verificarDisponibilidadZonasYVentaActivada();
        },
        beforeDestroy() {
            if (this.procesar_pago) {
                this.$refs.pago.clearAllIntervals();
            }

            if (typeof window !== 'undefined') {
                window.removeEventListener('resize', this.onResize, { passive: true })
            }
        },
        computed: {
            lista_abonados() {
                return this.$store.getters.getListaAbonados;
            },
            recinto() {
                return this.$store.getters.getRecinto;
            },
            configuracion() {
                return this.$store.getters.getConfig;
            },
            teatro(){
                return this.$store.getters.getTeatro
            },
            ocultarCupon() {
                return this.teatro?.hash === '8h04doWiX1E2m47WLMEP';
            },
            footer() {
                return this.$store.getters.getFooter;
            },
            renovacion() {
                return this.$route.query.dni != null && this.$route.query.n_abonado_antiguo != null ? 1 : 0;
            },
            esRenovacionConAsiento() {
                return this.renovacion 
                    && (this.$route.query.region_id || this.$route.query.plaza_id)
                    && !this.$route.query.seleccion_zona;
            },
            manager() {
                return this.$store.getters.getFooter;
            },
            hayPlazos() {
                return this.datos_guardados?.some(d => d.plazos) ?? false;
            },
            url() {
                return window.location.href;
            },
            zonas_anexas_disponibles() {
                return this.zonas_anexas && this.zonas_anexas.length > 0 && this.zonas_anexas.some(zona => zona.esta_disponible && zona.is_parking);
            },
            generos() {
                return this.$store.getters.getGeneros;
            },
            icImporteCarrito() {
                // Full cart total (sin gastos de gestion) — matches the displayed total
                // in the resumen across all modes (regular / plazos / parcelas),
                // including voucher / monedero / envio adjustments.
                return this.cartBase;
            },
            icGastosGestionUnitarios() {
                // OQ-2: per-cuota management fee from datos_guardados[].descuento.price_management
                if (!this.datos_guardados || !Array.isArray(this.datos_guardados)) return 0;
                const firstWithFee = this.datos_guardados.find(d => d.descuento?.price_management);
                return parseFloat(firstWithFee?.descuento?.price_management || 0);
            },
            icNumAbonados() {
                // Number of abonados in the cart. Instant Credit fees are per abonado,
                // so the UI total must multiply gastosGestionUnitarios by this count
                // to match what will actually be charged (fee × n_cuotas × num_abonados).
                if (!this.datos_guardados || !Array.isArray(this.datos_guardados)) return 1;
                return Math.max(this.datos_guardados.length, 1);
            }
        },
        mounted() {
            this.onResize()
            window.addEventListener('resize', this.onResize, { passive: true })
        },
        methods: {
            tiempoTerminado() {
                this.$router.go();
            },
            async bloquearAsientosWrapper(payload) {
                try {
                    return await this.bloquearConIdentificacion(payload);
                } catch (err) {
                    if (err && err.message === 'IDENTIFICACION_INVALIDA') {
                        // Mark identification as re-required; the host will route back to the step.
                        this.showIdentificacionStep = true;
                        throw err;
                    }
                    throw err;
                }
            },
            async onIdentificarSubmit({ n_abonado, dni }) {
                this.n_abonado_input = n_abonado;
                this.dni_input = dni;
                await this.identificarInicial();
                if (this.identificacionValida) {
                    this.showIdentificacionStep = false;
                }
            },
            onIdentificarReset() {
                this.limpiarIdentificacion();
                this.showIdentificacionStep = true;
            },
            onIdentificacionInvalidaEnBloqueo() {
                // The blocking call rejected with motivo=identificacion_invalida; reset seats
                // and route back to the identification step (per D-3).
                this.onResetSeats();
                this.showIdentificacionStep = true;
                if (typeof this.$toast !== 'undefined' && this.$toast?.error) {
                    this.$toast.error(this.$t('nuevo_abono.identificacion_invalida_en_bloqueo'));
                }
            },
            onResetSeats() {
                // Reset selected seats + downstream wizard state (per D-3 reset-on-422).
                this.asientos = [];
                this.datos_compradores = [];
                this.sessiones = [];
                this.zona = null;
                this.zonas_anexas = [];
                this.session_id = null;
                this.paso3 = false;
                this.paso4 = false;
                this.plazas_parking = false;
                this.reloadComponent += 1;
                this.borrarSesion();
            },
            actualizarDatosAbonado(event) {
                this.$set(this.datos_compradores, event.index, event.data);
            },
            volverDesdePreguntaEnvio() {
                this.paso4 = false;
                this.$nextTick(function() {
                    this.scrollTo('#paso3');
                });
            },
            volver() {

                if(this.pasoSeleccionParcelas && this.$refs.pasoParcelasRef)
                {
                    this.$refs.pasoParcelasRef.limpiarTodo();
                }

                if(this.$route.query.n_abonado_antiguo != null && this.$route.query.dni) {
                    this.$router.push({ name: 'front.abonos.renovar.index', query: { n_abonado_antiguo: this.$route.query.n_abonado_antiguo, dni: this.$route.query.dni } });
                } else {
                    this.reloadComponent += 1;
                    this.paso3 = false;
                    this.paso4 = false;
                    this.pasoSeleccionParcelas = false;
                    this.zonaParcelasSeleccionada = null;
                    this.parcelasSleccionadas = [];
                    this.preguntaParcelas = false;
                    this.resumen = false;
                    this.voucher = false;
                    this.$nextTick(function() {
                        this.scrollTo('#paso1');
                    });
                }
            },
            cambiarAsiento() {
                if(this.$route.query.n_abonado_antiguo != null && this.$route.query.dni) {
                    this.$router.push({ name: 'front.abonos.renovar.index', query: { n_abonado_antiguo: this.$route.query.n_abonado_antiguo, dni: this.$route.query.dni } });
                } else {
                    this.changeSeat += 1;
                    this.paso3 = false;
                    this.paso4 = false;
                    this.resumen = false;
                    this.$nextTick(function() {
                        this.scrollTo('#paso2');
                    });
                }
                this.datos_compradores = [];
                this.asientos = [];
                this.sessiones = [];
                this.borrarSesion();
            },
            borrarSesion(){
                if (sessionStorage.getItem('session_id')) {
                    const params = {
                        session_id: sessionStorage.getItem('session_id'),
                        filters: {
                            session_id: sessionStorage.getItem('session_id'),
                            tid: this.configuracion.hash_teatro
                        },
                        tid: this.configuracion.hash_teatro,
                    };

                    this.$store.dispatch(this.config.getVuexAlias('front.borrar.sesion'), params).then(res => {
                        this.plazas_parking = false;
                        this.reloadComponent++;
                    });

                    sessionStorage.removeItem('session_id');
                }
            },
            scrollTo(paso) {
                this.$scrollTo(paso, 500)
            },
            async buscarAbonado(n_abonado_antiguo, dni) {
                this.buscando_abonado = true;

                const params = {
                    filters: {
                        tid: this.configuracion.hash_teatro,
                        dni: dni,
                        n_abonado_antiguo: n_abonado_antiguo
                    }
                }

                const session_id = sessionStorage.getItem('session_id');
                if (session_id) {
                    params.session_id = session_id;
                    params.filters.session_id = session_id;
                }

                this.$store.dispatch(this.config.getVuexAlias('front.abonados.buscar'), params).then(async res => {
                    this.abonado = res.data.abonado;
                    this.abonado.asiento = res.data.asiento;
                    if (this.abonado.asiento && !this.abonado.asiento.zona_id) {
                        this.abonado.asiento.zona_id = this.abonado.asiento.region_id;
                    }
                    this.abonado.plaza = res.data.plaza;
                    this.abonado.tipos_abonos = res.data.tipos_abonos;

                    const abonado_ids = this.$route.query.abonado_ids;
                    if (abonado_ids && res.data.familia?.miembros) {
                        const ids = abonado_ids.split(',').map(Number);
                        const miembros = res.data.familia.miembros.filter(m => ids.includes(m.id) && m.id !== this.abonado?.id);

                        this.zona = { precios: [], tipos_abonos: this.abonado.tipos_abonos || [] };
                        this.datos_compradores = [];

                        // Main abonado
                        this.datos_compradores.push({
                            nombre: this.abonado.name || '',
                            apellidos: this.abonado.surnames || '',
                            dni: this.abonado.dni || '',
                            fecha_nacimiento: this.abonado.fecha_nacimiento || null,
                            email: this.abonado.email || null,
                            telefono: this.abonado.telefono || null,
                            provincia: this.abonado.provincia || null,
                            localidad: this.abonado.localidad || null,
                            domicilio: this.abonado.domicilio || null,
                            cp: this.abonado.cp || null,
                            pais: this.abonado.pais || null,
                            genero: this.generos?.find(genero => genero.id === this.abonado.genero_id),
                            n_abonado_antiguo: this.abonado.n_abonado_antiguo || '',
                            penista: this.abonado.penista || null,
                            importe_monedero: this.abonado.importe_monedero || null,
                            asiento: this.abonado.asiento,
                            plaza: this.abonado.plaza,
                            tipos_abonos: this.abonado.tipos_abonos,
                            abonado_id: this.abonado.id
                        });

                        // Selected family members (from API)
                        miembros.forEach(m => {
                            if (m.asiento && !m.asiento.zona_id) {
                                m.asiento.zona_id = m.asiento.region_id;
                            }
                            this.datos_compradores.push({
                                nombre: m.name || '',
                                apellidos: m.surnames || '',
                                dni: m.dni || '',
                                fecha_nacimiento: m.fecha_nacimiento || null,
                                email: m.email || null,
                                telefono: m.telefono || null,
                                provincia: m.provincia || null,
                                localidad: m.localidad || null,
                                domicilio: m.domicilio || null,
                                cp: m.cp || null,
                                pais: m.pais || null,
                                genero: this.generos?.find(genero => genero.id === m.genero_id),
                                n_abonado_antiguo: m.n_abonado_antiguo || '',
                                penista: m.penista || null,
                                importe_monedero: null,
                                asiento: m.asiento,
                                plaza: m.plaza,
                                tipos_abonos: m.tipos_abonos || this.abonado.tipos_abonos,
                                abonado_id: m.id
                            });
                        });

                        // Members not found in API (e.g. just added via modal) — from sessionStorage
                        const miembrosEncontrados = new Set(miembros.map(m => m.id));
                        const idsFaltantes = ids.filter(id => !miembrosEncontrados.has(id));
                        let sessionData = [];
                        if (idsFaltantes.length) {
                            try {
                                sessionData = JSON.parse(sessionStorage.getItem('familia_seleccionados') || '[]');
                                idsFaltantes.forEach(id => {
                                    const m = sessionData.find(s => s.id === id);
                                    if (m) {
                                        if (m.asiento && !m.asiento.zona_id) {
                                            m.asiento.zona_id = m.asiento.region_id;
                                        }
                                        this.datos_compradores.push({
                                            nombre: m.name || '',
                                            apellidos: m.surnames || '',
                                            dni: m.dni || '',
                                            fecha_nacimiento: null,
                                            email: null,
                                            telefono: null,
                                            provincia: null,
                                            localidad: null,
                                            domicilio: null,
                                            n_abonado_antiguo: m.n_abonado_antiguo || '',
                                            penista: null,
                                            importe_monedero: null,
                                            asiento: m.asiento,
                                            plaza: m.plaza,
                                            tipos_abonos: this.abonado.tipos_abonos,
                                            abonado_id: m.id
                                        });
                                    }
                                });
                            } catch (e) {
                                console.error('Error reading sessionStorage familia_seleccionados:', e);
                            }
                        } else {
                            // Read sessionStorage even if all came from API, for n_abonado_antiguo fallback
                            try {
                                sessionData = JSON.parse(sessionStorage.getItem('familia_seleccionados') || '[]');
                            } catch (e) {
                                console.error('Error reading sessionStorage familia_seleccionados:', e);
                            }
                        }

                        // Fill missing n_abonado_antiguo for family members from sessionStorage
                        if (sessionData.length) {
                            for (let i = 1; i < this.datos_compradores.length; i++) {
                                if (!this.datos_compradores[i].n_abonado_antiguo) {
                                    const m = sessionData.find(s => s.id === this.datos_compradores[i].abonado_id);
                                    if (m?.n_abonado_antiguo) {
                                        this.$set(this.datos_compradores[i], 'n_abonado_antiguo', m.n_abonado_antiguo);
                                    }
                                }
                            }
                        }

                        // Block seats before showing paso3
                        try {
                            await this.bloquearAsientosRenovacion();
                        } catch (e) {
                            this.$toast.error('Error al reservar las butacas. Inténtalo de nuevo.');
                            this.$router.push({
                                name: 'front.abonos.renovar.index',
                                query: {
                                    n_abonado_antiguo: this.$route.query.n_abonado_antiguo,
                                    dni: this.$route.query.dni
                                }
                            });
                            return;
                        }

                        this.paso3 = true;
                        this.$nextTick(() => {
                            this.scrollTo('#paso3');
                        });
                    } else if (!this.abonado) {
                        this.$router.push({
                            name: 'front.abonos.renovar.index',
                            query: {
                                n_abonado_antiguo: this.$route.query.n_abonado_antiguo,
                                dni: this.$route.query.dni
                            }
                        });
                        return;
                    } else if (this.esRenovacionConAsiento) {
                        // Renovation with existing seat — skip zone selection
                        this.zona = { precios: [], tipos_abonos: this.abonado.tipos_abonos || [] };
                        this.datos_compradores = [{
                            nombre: this.abonado.name || '',
                            apellidos: this.abonado.surnames || '',
                            dni: this.abonado.dni || '',
                            fecha_nacimiento: this.abonado.fecha_nacimiento || null,
                            email: this.abonado.email || null,
                            telefono: this.abonado.telefono || null,
                            provincia: this.abonado.provincia || null,
                            localidad: this.abonado.localidad || null,
                            domicilio: this.abonado.domicilio || null,
                            cp: this.abonado.cp || null,
                            pais: this.abonado.pais || null,
                            genero: this.generos?.find(genero => genero.id === this.abonado.genero_id),
                            n_abonado_antiguo: this.abonado.n_abonado_antiguo || '',
                            penista: this.abonado.penista || null,
                            importe_monedero: this.abonado.importe_monedero || null,
                            asiento: this.abonado.asiento,
                            plaza: this.abonado.plaza,
                            tipos_abonos: this.abonado.tipos_abonos,
                            abonado_id: this.abonado.id
                        }];

                        // Block seat before showing paso3
                        try {
                            await this.bloquearAsientosRenovacion();
                        } catch (e) {
                            this.$toast.error('Error al reservar la butaca. Inténtalo de nuevo.');
                            this.$router.push({
                                name: 'front.abonos.renovar.index',
                                query: {
                                    n_abonado_antiguo: this.$route.query.n_abonado_antiguo,
                                    dni: this.$route.query.dni
                                }
                            });
                            return;
                        }

                        this.paso3 = true;
                        this.$nextTick(() => {
                            this.scrollTo('#paso3');
                        });
                    }
                }).finally(() => this.buscando_abonado = false);
            },
            async bloquearAsientosRenovacion() {
                const seats = [];
                const plazas = [];

                this.datos_compradores.forEach(d => {
                    // Seat-type (asiento)
                    if (d.asiento) {
                        seats.push({
                            seat: d.asiento.asiento || d.asiento.seat,
                            row: d.asiento.fila || d.asiento.row,
                            zona_id: d.asiento.zona_id ?? d.asiento.region_id,
                            abonado_id: d.abonado_id || null
                        });
                    }
                    // Plaza-type
                    if (d.plaza) {
                        plazas.push({
                            id: d.plaza.id,
                            region_id: d.plaza.region_id ?? d.plaza.zona_id,
                            abonado_id: d.abonado_id || null
                        });
                    }
                });

                if (!seats.length && !plazas.length) return;

                const params = {
                    filters: { tid: this.configuracion.hash_teatro },
                    tid: this.configuracion.hash_teatro,
                    butacas: plazas,
                    asientos: seats
                };

                const res = await this.$store.dispatch(this.config.getVuexAlias('front.bloquear.asientos'), params);
                this.session_id = res.data.session_id;
                sessionStorage.setItem('session_id', res.data.session_id);
            },
            scrollToFirstError() {
                this.$nextTick(() => {
                    const firstInvalid = document.querySelector('.is-invalid');
                    if (firstInvalid) {
                        this.$scrollTo(firstInvalid, 300, { offset: -100 });
                    } else {
                        this.scrollTo('#paso3');
                    }
                });
            },
            async finalizarPasoTres() {
                const errors = Object.keys(this.$refs.observer.errors).some(
                    field => this.$refs.observer.errors[field].length > 0
                );

                if(errors) {
                    this.scrollToFirstError();
                    return;
                }

                const isValid = await this.$refs.observer.validate()

                const tienen_telefono = this.datos_compradores.filter(datos_comprador => {
                    return !isNaN(datos_comprador.telefono) && datos_comprador.telefono != null && datos_comprador.telefono_valido;
                }).length === this.datos_compradores.length;

                if (isValid && tienen_telefono) {
                    this.error_telefono = 0;
                    this.dni_error = false;

                    var DNI = [];

                    for (var i = 0; i < this.datos_compradores.length; i++) {
                        if(this.datos_compradores[i].precio) {

                            if(!this.datos_compradores[i].precio.solicitar_documentacion) {
                                this.documentacion_error = false;
                            } else if(this.datos_compradores[i].documentaciones && this.datos_compradores[i].documentaciones.length > 0) {
                                this.documentacion_error = false;
                            } else {
                                this.documentacion_error = true;
                                break;
                            }

                        } else {
                            this.documentacion_error = false;
                        }

                        DNI.push(this.datos_compradores[i].dni);
                    }

                    if(DNI.length > 0 && this.manager.comprobar_dni && ! this.renovacion){
                        // Guard against double submits: the flag is cleared in
                        // the finally, after the response lands.
                        if (this.dniCheckLoading) {
                            return;
                        }

                        this.dniCheckLoading = true;

                        const params = {
                            filters: {
                                tid: this.configuracion.hash_teatro
                            },
                            dni: DNI
                        }

                        this.$store.dispatch(this.config.getVuexAlias('front.comprobar.datos.comprador.dni'), params).catch(() => {
                            this.dni_error = true;
                        }).finally(()=> {
                            this.dniCheckLoading = false;
                            this.finalizarPasoTresComprobados();
                        });

                    }else {
                        this.finalizarPasoTresComprobados();
                    }
                } else {
                    this.error_telefono += 1;
                    this.scrollToFirstError();
                }
            },
            async finalizarPasoTresComprobados(){
                if(!this.documentacion_error && !this.dni_error) {
                    if (this.lista_abonados.permitir_envio_a_domicilio) {
                        this.paso4 = true;
                        this.$nextTick(function() {
                            this.scrollTo('#paso4');
                        });
                    }
                    else {
                        this.showVoucher();
                    }
                }
            },
            async envioSolicitado(datos_envio) {
                this.datos_compradores.forEach(datos_comprador => {
                    datos_comprador.datos_envio = [];
                })

                this.datos_compradores[0].datos_envio = {
                    nombre: datos_envio.nombre != "" ? datos_envio.nombre : this.datos_compradores[0].nombre,
                    apellidos: datos_envio.apellidos != "" ? datos_envio.apellidos : this.datos_compradores[0].apellidos,
                    domicilio: datos_envio.domicilio != "" ? datos_envio.domicilio : this.datos_compradores[0].domicilio,
                    cp: datos_envio.cp != "" ? datos_envio.cp : this.datos_compradores[0].cp,
                    telefono: datos_envio.telefono != "" ? datos_envio.telefono : this.datos_compradores[0].telefono,
                    observaciones: datos_envio.observaciones,
                    gastos_envio: datos_envio.gastos_envio,
                    provincia : datos_envio.provincia != "" ? datos_envio.provincia : this.datos_compradores[0].provincia,
                    localidad: datos_envio.localidad != "" ? datos_envio.localidad : this.datos_compradores[0].localidad,
                    importe_total: this.datos_compradores.reduce((acumulador, abono) => {
                        return acumulador + abono.precio ? abono.precio.precio : abono.tipo_abono.precio;
                    }, 0)
                }

                this.envio_domicilio = true;

                this.showVoucher();

            },
            aplicarDescuento(descuento) {
                this.datos_compradores[0]['descuento_monedero'] = descuento;
                this.guardarDatos();
            },
            cancelarDescuento() {
                this.datos_compradores[0]['descuento_monedero'] = 0;
                this.guardarDatos();
            },
            guardarDatos() {
                this.resumen_loading = true;

                const params = {
                    filters: {
                        sesion_id: this.sesion_id,
                        tid: this.configuracion.hash_teatro
                    },
                    datos_compradores: this.datos_compradores,
                    session_id: this.session_id,
                    tid: this.configuracion.hash_teatro
                }

                const abonado_ids = this.$route.query.abonado_ids;
                if (abonado_ids) {
                    params.abonado_ids = abonado_ids.split(',').map(Number);
                }

                this.$store.dispatch(this.config.getVuexAlias('front.guardar.datos.comprador'), params).then(res => {
                    this.jet_id = res.data.jet_id;
                    this.formulario = res.data.formulario;
                    this.datos_guardados = res.data.datos_compradores;
                    this.resumen_loading = false;
                    this.resumen_error = false;
                }).catch(error => {
                    this.resumen_error = error.response.data.message;
                    this.resumen_loading = false;
                });
            },
            aplicarPlazos(datos) {
                this.resumen_loading = true;
                this.datos_guardados = null;
                this.datos_compradores = datos;
                this.resumen = true;
                this.guardarDatos();
            },
            resetPlazos() {
                this.resumen_loading = true;
                this.datos_guardados = null;
                this.datos_compradores.forEach(dato => {
                    dato.plazos = false,
                    dato.plazos_pendientes = null;
                });
                this.resumen = true;
                this.guardarDatos();
            },
            compraConfirmada() {

                this.procesar_pago = true;
                this.$nextTick(function() {
                    this.scrollTo('#pago');
                });
            },
            showModal(modal)  {
                this.$modal.show(modal)
            },
            showVoucher() {
                if (this.ocultarCupon) {
                    // Teatro Liceo: ocultar el paso del cupón de descuento; avanzar
                    // guardando los datos (equivale a pulsar "Continuar sin cupón").
                    return this.cuponAplicado();
                }
                this.voucher = true;
                this.$nextTick(function() {
                    this.scrollTo('#voucher');
                });
            },
            async cuponAplicado() {
                const parcelasDisponibles = await this.verificarDisponibilidadZonasYVentaActivada();
                if (parcelasDisponibles) {
                    this.preguntaParcelas = true;
                    this.$nextTick(() => {
                        this.scrollTo('#preguntaParcelas');
                    });
                } else {
                    this.$nextTick(() => {
                        this.resumen = true;
                        this.$nextTick(() => {
                            setTimeout(() => {
                                this.scrollTo('#resumen');
                            }, 300);
                        });
                    });
                }
                this.guardarDatos();
            },
            butacasBloqueadas(datos_compradores, asientos, zona, session_id, zonas_anexas) {
                this.zonas_anexas = zonas_anexas;

                const esParking = zona.is_parking;
                if (!esParking) {
                    this.datos_compradores = [];
                    this.asientos = [];
                }
                datos_compradores.forEach(datos_comprador => {
                    if(zona.tipo_svg == 1) {
                        datos_comprador.tipos_abonos = zona.tipos_abonos;
                    }
                    this.datos_compradores.push(datos_comprador);
                });
                asientos.forEach(asiento => {
                    this.asientos.push(asiento);
                });
                this.zona = zona;
                this.session_id = session_id;

                const { trackBeginCheckout } = useAbonoTracking({ store: this.$store, getVuexAlias: this.config.getVuexAlias });

                trackBeginCheckout({
                    abono_id: this.lista_abonados.id,
                    abono_name: this.lista_abonados.nombre,
                    lista_abonados: [this.lista_abonados],
                    resumen_total: this.zona?.precio_total || 0,
                    moneda: this.configuracion?.moneda || 'EUR',
                }, this.asientos);

                if (!zona.is_parking && this.asientos.length > 0 && this.zonas_anexas_disponibles) {
                    this.plazas_parking = true;

                    this.$nextTick(function() {
                        this.scrollTo('#plazas_parking');
                    });
                } else {
                    this.plazas_parking = false;
                    this.paso3 = true;

                    this.$nextTick(function() {
                        this.scrollTo('#paso3');
                    });
                }
            },
            avanzarPaso(quiere_plaza) {
                if (!quiere_plaza) {
                    this.plazas_parking = false;
                    this.paso3 = true;

                    this.$nextTick(function() {
                        this.scrollTo('#paso3');
                    });
                }
            },
            onResize() {
                this.esMovil = window.innerWidth < 768
            },
            continuarDesdeSeleccionParcelas(parcelasSeleccionadas){
                this.parcelasSeleccionadas = parcelasSeleccionadas;
            },
            volverDesdeSeleccionParcelas(){
                this.pasoSeleccionParcelas = false;
                this.botonesParcelasDeshabilitados = false;
                if (this.ocultarCupon) {
                    this.resumen = true;
                    this.$nextTick(() => {
                        this.scrollTo('#resumen');
                    });
                    return;
                }
                this.$nextTick(() => {
                    this.scrollTo('#voucher');
                });

            },
            continuarDespuesdeAsignaciones(datosParcelas){
                if (datosParcelas) {
                    this.cart_ids_parcelas = datosParcelas.cart_ids || [];
                    this.jet_id = datosParcelas.jet_id || null;
                    this.datos_parcelas_compradas = datosParcelas.datos_parcelas_resumen || [];
                }
                this.resumen = true;
                this.$nextTick(function() {
                    this.scrollTo('#resumen');
                });
            },
            async verificarDisponibilidadZonasYVentaActivada() {
                try{
                    if(!this.lista_abonados.activar_parcelas || !this.manager.activar_parcelas)
                    {
                        return false;
                    }

                    const params= {
                        lista_abonado_id: this.lista_abonados.id,
                        place_id: this.lista_abonados.recinto_parcela_id,
                    }

                    const response = await this.$store.dispatch('FRONT_PARCELAS_ZONAS', params);
                    const zonas = response.data.data;
                    const hayZonasDisponibles = zonas.some(zona => zona.esta_disponible > 0);

                    return hayZonasDisponibles;
                }
                catch(error)
                {
                    console.error('Venta de parcela desactivada.');
                }
            },
            respuestaParcelas(quiereParcelas) {
                this.botonesParcelasDeshabilitados = true;
                if (quiereParcelas) {
                    this.quiereParcelasCambiarColor = false;
                    this.pasoSeleccionParcelas = true;
                    this.$nextTick(() => {
                        const elemento = document.getElementById('pasoSeleccionParcelas');
                        if (elemento) {
                            this.scrollTo('#pasoSeleccionParcelas');
                        }
                    });
                } else {
                    this.quiereParcelasCambiarColor = true;
                    this.resumen = true;
                    this.$nextTick(() => {
                        this.scrollTo('#resumen');
                    });
                }
            },
            volverDesdePreguntaParcelas() {
                this.preguntaParcelas = false;
                this.botonesParcelasDeshabilitados = false;
                if (this.ocultarCupon) {
                    // Sin paso de cupón: los datos ya se guardaron en cuponAplicado();
                    // volver directo al resumen.
                    this.resumen = true;
                    this.$nextTick(() => {
                        this.scrollTo('#resumen');
                    });
                    return;
                }
                this.voucher = true;
                this.$nextTick(() => {
                    this.scrollTo('#voucher');
                });
            },
            volverDesdeResumenCompra(){
                this.resumen = false;
                this.botonesParcelasDeshabilitados = false;

                if (this.pasoSeleccionParcelas) {
                    if (this.$refs.pasoParcelasRef) {
                        this.$refs.pasoParcelasRef.enviandoAsignaciones = false;
                        if (typeof this.$refs.pasoParcelasRef.habilitarSVGParcelas === 'function') {
                            this.$refs.pasoParcelasRef.habilitarSVGParcelas();
                        }
                    }
                    this.borrarParcelasSeleccionadas();

                    this.$nextTick(() => {
                        this.scrollTo('#pasoSeleccionParcelas');
                    });
                }
            },
            async borrarParcelasSeleccionadas() {
                if (this.cart_ids_parcelas.length === 0) {
                    this.limpiarDatosParcelas();
                    return;
                }

                for (const cartId of this.cart_ids_parcelas) {
                    try {
                        const params = { cart_id: cartId };
                        await this.$store.dispatch(this.config.getVuexAlias('front.parcelas.carrito.borrar'), params);
                    } catch (error) {
                        this.$toast.error(`Error borrando cart_id ${cartId}:`);
                    }
                }

                this.limpiarDatosParcelas();
            },
            limpiarDatosParcelas() {
                this.zonaParcelasSeleccionada = null;
                this.parcelasSeleccionadas = [];
                this.datos_parcelas_compradas = [];
            },
            sessionButacaDataPadre(data) {
                data.sesiones?.forEach(session => {
                    this.sessiones.push(session);
                });
            },
            continuarSinPlazaParking() {
                this.plazas_parking = false;
                this.paso3 = true;

                this.$nextTick(() => {
                    this.scrollTo('#paso3');
                });
            },
            volverDesdeParking() {
                this.datos_compradores = [];
                this.asientos = [];
                this.sessiones = [];
                this.borrarSesion();
                setTimeout(() => {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                }, 300);
            }
        },
        components: {
            SeleccionarAsientosConRegiones, EnviosComponent,
            DatosAbonoComponent, ResumenCompraComponent, PagoPaycometComponent, CheckVoucherComponent,
            SeleccionarAsientosMapaGeneral, PageTitle, CuentaAtras, SeleccionarAsientoConSecciones,
            PasoCompraParcelasOnline, PreguntaPrevioPasoParcelas, PasoExtraPlazasParking, Button, LoaderComponent,
            IdentificacionPrivadaStep
        }
    }
</script>

<style scoped>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .2s;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }

    button:disabled,
    .btn:disabled {
        cursor: not-allowed ;
        opacity: 0.6 ;
    }

    button:disabled:hover,
    .btn:disabled:hover {
        cursor: not-allowed ;
    }

    @media (max-width: 700px) {
        .button.large-button {
            min-width: 40vw !important;
            margin-right: 4%;
        }

        .form-button-responsive {
            display: flex;
            justify-content: center;
        }
        #compra-responsive {
            min-width: 45px;
            font-size: 13px;
        }
        #atras-responsive {
            min-width: 168px;
            font-size: 13px;
        }
    }
</style>
